var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:_vm.theme},[_c('td',{attrs:{"colspan":_vm.colsCount}},[_c('div',{staticClass:"date-separator-wrap"},[_c('div',{staticClass:"date-separator",class:_vm.separatorClass}),_c('div',{staticClass:"date",class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"date-separator",class:_vm.separatorClass})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }